/**
 * Iconos de línea. Sustituyen a los emojis (🏠 📅 🏖️ 📥 🚨) que había antes:
 * un producto de cumplimiento legal no puede parecer un juguete, y los emojis
 * se dibujan distinto en cada sistema — no son iconografía, son lotería.
 */
interface IconProps {
  name: IconName;
  size?: number;
  className?: string;
  strokeWidth?: number;
  style?: React.CSSProperties;
}

export type IconName =
  | 'clock'
  | 'calendar'
  | 'palm'
  | 'file'
  | 'pin'
  | 'pin-off'
  | 'play'
  | 'stop'
  | 'pause'
  | 'wifi'
  | 'wifi-off'
  | 'camera'
  | 'chevron-left'
  | 'shield'
  | 'alert'
  | 'info'
  | 'edit'
  | 'sun'
  | 'eye'
  | 'eye-off'
  | 'moon'
  | 'kiosk'
  | 'coffee'
  | 'cigarette'
  | 'toilet'
  | 'utensils'
  | 'phone'
  | 'clipboard'
  | 'errand'
  | 'dots'
  | 'mail'
  | 'check-circle'
  | 'users'
  | 'building'
  | 'home'
  | 'printer'
  | 'plus'
  | 'arrow-right'
  | 'star';

const PATHS: Record<IconName, string[]> = {
  clock: ['M12 7v5l3 2', 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18'],
  mail: ['M3 5h18v14H3z', 'M3 7l9 6 9-6'],
  'check-circle': ['M8 12.5l2.6 2.6L16.5 9', 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18'],
  users: ['M16 21v-2a4 4 0 0 0-8 0v2', 'M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8'],
  building: ['M3 21h18', 'M5 21V7l7-4 7 4v14', 'M9 9h.01M15 9h.01'],
  home: ['M3 10.5L12 3l9 7.5', 'M5 9.5V21h14V9.5', 'M10 21v-6h4v6'],
  printer: ['M6 9V4h12v5', 'M6 18H4v-4h16v4h-2', 'M8 14h8v6H8z'],
  plus: ['M12 5v14M5 12h14'],
  'arrow-right': ['M5 12h14', 'M13 6l6 6-6 6'],
  star: ['M12 2l2.4 7.4H22l-6 4.4 2.3 7.2-6.3-4.6L5.7 21l2.3-7.2-6-4.4h7.6z'],
  calendar: ['M3 4h18v17H3z', 'M3 9h18', 'M8 2v4', 'M16 2v4'],
  palm: ['M12 3v18', 'M5 12l7-9 7 9', 'M4 20h16'],
  file: ['M6 2h9l5 5v15H6z', 'M14 2v6h6'],
  pin: ['M12 21s-7-5.5-7-11a7 7 0 0 1 14 0c0 5.5-7 11-7 11z', 'M12 10a2.6 2.6 0 1 0 0-.1'],
  'pin-off': ['M12 21s-7-5.5-7-11a7 7 0 0 1 14 0c0 5.5-7 11-7 11z', 'M9.5 9.5l5 5', 'M14.5 9.5l-5 5'],
  play: ['M8 5v14l11-7z'],
  stop: ['M7 7h10v10H7z'],
  pause: ['M8 5v14', 'M16 5v14'],
  wifi: ['M5 12.5a7 7 0 0 1 14 0', 'M8.5 15.5a3.5 3.5 0 0 1 7 0', 'M12 19h.01'],
  'wifi-off': ['M3 3l18 18', 'M8.5 15.5a3.5 3.5 0 0 1 5 0', 'M12 19h.01'],
  camera: ['M3 7h4l1.5-2h7L17 7h4v13H3z', 'M12 16a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4z'],
  'chevron-left': ['M15 5l-7 7 7 7'],
  shield: ['M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6z', 'M9 12l2 2 4-4'],
  alert: ['M12 3l9 16H3z', 'M12 10v4', 'M12 17h.01'],
  info: ['M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18', 'M12 11v5', 'M12 8h.01'],
  edit: ['M12 20h9', 'M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z'],
  sun: ['M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8', 'M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4'],
  moon: ['M20 14.5A8 8 0 0 1 9.5 4a6.5 6.5 0 1 0 10.5 10.5z'],
  eye: ['M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z', 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z'],
  'eye-off': ['M9.9 5.2A9.5 9.5 0 0 1 12 5c6.5 0 10 7 10 7a17 17 0 0 1-3.2 4M6.6 6.6A17 17 0 0 0 2 12s3.5 7 10 7a9.5 9.5 0 0 0 4.1-.9', 'M3 3l18 18', 'M9.9 9.9a3 3 0 0 0 4.2 4.2'],
  kiosk: ['M4 3h16v18H4z', 'M9 7h6', 'M9 11h6', 'M9 15h3'],
  coffee: ['M4 8h13v4a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5z', 'M17 9h2a2 2 0 0 1 0 4h-2'],
  cigarette: ['M3 15h14v3H3z', 'M19 12v-2', 'M21 15v3'],
  toilet: ['M5 21v-6H4l2-6h2l2 6H9v6', 'M7 6a2 2 0 1 0 0-.1', 'M15 21v-5M19 21v-5', 'M14 11h6l-1 5h-4z', 'M17 6a2 2 0 1 0 0-.1'],
  utensils: ['M4 3v7a2 2 0 0 0 4 0V3', 'M6 10v11', 'M18 3c-2 0-3 2-3 5s1 4 3 4v9'],
  phone: ['M5 4h4l2 5-3 2a11 11 0 0 0 5 5l2-3 5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2'],
  clipboard: ['M6 2h9l5 5v15H6z', 'M14 2v6h6', 'M9 13h6', 'M9 17h4'],
  errand: ['M3 10h13v7H3z', 'M16 12h3l2 3v2h-5', 'M7 20a2 2 0 1 0 0-.1', 'M18 20a2 2 0 1 0 0-.1'],
  dots: ['M12 8v8', 'M8 12h8', 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18'],
};

export function Icon({ name, size = 24, className = '', strokeWidth = 1.7, style }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={style}
      aria-hidden="true"
    >
      {PATHS[name].map((d) => (
        <path key={d} d={d} />
      ))}
    </svg>
  );
}
